import * as React from 'react';
import { replace } from 'ramda';

import { IRutinInfo } from '../../../../Types/RutinInfoType';

import ARRutinMeny from './DelsystemConsts/ARRutinMeny';
import ARStyrvardeMeny from './DelsystemConsts/ARStyrvardeMeny';
import ARRapportMeny from './DelsystemConsts/ARRapportMeny';

import BORutinMeny from './DelsystemConsts/BORutinMeny';
import BOStyrvardeMeny from './DelsystemConsts/BOStyrvardeMeny';
import BORapportMeny from './DelsystemConsts/BORapportMeny';

import DIRutinMeny from './DelsystemConsts/DIRutinMeny';
import DIStyrvardeMeny from './DelsystemConsts/DIStyrvardeMeny';
import DIRapportMeny from './DelsystemConsts/DIRapportMeny';

import EKRutinMeny from './DelsystemConsts/EKRutinMeny';
import EKStyrvardeMeny from './DelsystemConsts/EKStyrvardeMeny';
import EKRapportMeny from './DelsystemConsts/EKRapportMeny';

import GARutinMeny from './DelsystemConsts/GARutinMeny';
import GAStyrvardeMeny from './DelsystemConsts/GAStyrvardeMeny';
import GARapportMeny from './DelsystemConsts/GARapportMeny';

import KJRutinMeny from './DelsystemConsts/KJRutinMeny';
import KJStyrvardeMeny from './DelsystemConsts/KJStyrvardeMeny';
import KJRapportMeny from './DelsystemConsts/KJRapportMeny';

import KRRutinMeny from './DelsystemConsts/KRRutinMeny';
import KRStyrvardeMeny from './DelsystemConsts/KRStyrvardeMeny';
import KRRapportMeny from './DelsystemConsts/KRRapportMeny';

import LRRutinMeny from './DelsystemConsts/LRRutinMeny';
import LRStyrvardeMeny from './DelsystemConsts/LRStyrvardeMeny';
import LRRapportMeny from './DelsystemConsts/LRRapportMeny';

import MURutinMeny from './DelsystemConsts/MURutinMeny';
import MUStyrvardeMeny from './DelsystemConsts/MUStyrvardeMeny';
import MURapportMeny from './DelsystemConsts/MURapportMeny';

import OFRutinMeny from './DelsystemConsts/OFRutinMeny';
import OFStyrvardeMeny from './DelsystemConsts/OFStyrvardeMeny';
import OFRapportMeny from './DelsystemConsts/OFRapportMeny';

import PURutinMeny from './DelsystemConsts/PURutinMeny';
import PUStyrvardeMeny from './DelsystemConsts/PUStyrvardeMeny';
import PURapportMeny from './DelsystemConsts/PURapportMeny';

import SYSRutinMeny from './DelsystemConsts/SYSRutinMeny';
import SYSStyrvardeMeny from './DelsystemConsts/SYSStyrvardeMeny';
import SYSRapportMeny from './DelsystemConsts/SYSRapportMeny';

import TIRutinMeny from './DelsystemConsts/TIRutinMeny';
import TIStyrvardeMeny from './DelsystemConsts/TIStyrvardeMeny';
import TIRapportMeny from './DelsystemConsts/TIRapportMeny';

import BJRutinMeny from './DelsystemConsts/BJRutinMeny';
import BJStyrvardeMeny from './DelsystemConsts/BJStyrvardeMeny';
import BJRapportMeny from './DelsystemConsts/BJRapportMeny';

import anlaggningBild from '../../../../Assets/Branding/anlaggning-isolated.svg';
import bokningBild from '../../../../Assets/Branding/bokning-isolated.svg';
import diariumBild from '../../../../Assets/Branding/diarie-isolated.svg';
import ekonomiBild from '../../../../Assets/Branding/ekonomi-isolated.svg';
import gravBild from '../../../../Assets/Branding/grav-isolated.svg';
import kremationsjournalBild from '../../../../Assets/Branding/kremering-isolated.svg';
import kundreskontraBild from '../../../../Assets/Branding/kundreskontra-isolated.svg';
import leverantorsreskontraBild from '../../../../Assets/Branding/leverantorsreskontra-isolated.svg';
import musikBild from '../../../../Assets/Branding/musik-isolated.svg';
import orderBild from '../../../../Assets/Branding/underlag-isolated.svg';
import bisattningsBild from '../../../../Assets/Branding/bisattning-isolated.svg';

import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import { IconType } from '../../../../BaseComponents/Icon/Utils/IconDefinitions';
import { ICustomBusinessConfigs } from './BusinessConfigs';
import { OnStartWarningHook } from './Rutiner';
import { TVisningstyp } from '../Components/BusinessCollectionComponents/BusinessDataSet/BusinessDataSet';
import { SideBySideWidthType } from '../../../../Utils/ObjektVyUtils';
import { CommonPropsAndTypes } from '../../../../BaseComponents/_Types/StandardComponentProps';
import { ICollectionDataType } from '../Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { IRapportInfo } from '../../../../Types/RapportInfoType';
import { Breakpoint } from '../../../../BaseComponents/ThemeProvider/AvenyTheme';
import { SelectNewDetailType } from '../../_StandardRutin/StandardRutin';
import type { ApolloCache } from '@apollo/client/cache/core/cache';

export enum LeveransStatus {
  EndastRegistrerad, // Rutiner som inte kan startas (många rutiner där registreringen av rutinen är konverterad från Aveny men utvecklingen inte påbörjad)
  IUtveckling, // Kan startas man ställt in det i databasen (betyder inte att det är en bra ide att köra hos kund, behöver vi skilja på det i koden får vi införa fler statusar)
  IDrift, // Kan startas i alla databaser om man är behörig
}

export enum ShowDetailsRight {
  DefaultFalse,
  DefaultTrue,
  Disabled,
}

export type ShowDetailsRightSizeType = SideBySideWidthType | string;

export interface IFilterAttribute {
  attribute: string;
  label: string;
}

export type BusinessMenuButtons =
  | 'add'
  | 'column'
  | 'sort'
  | 'urval'
  | 'refresh'
  | 'excel'
  | 'rapport';

export interface IRenderButtonProps {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  title?: string;
  icon: IconType | React.JSX.Element;
  label: string;
}

export interface ICustomAddButtonProps {
  setNewObject?: SelectNewDetailType;
  /** Knappen visas i den lilla mobilanpassade menyn */
  smallMenu?: boolean;
  /** Custom render function for the trigger button. When provided, takes priority over smallMenu. */
  renderButton?: (props: IRenderButtonProps) => React.ReactNode;
  expanded?: boolean;
  testId?: string;
}

export interface ICustomBottomToolbarProps {
  sideMenuOpen: boolean;
}
export interface IRoutine {
  component:
    | React.ComponentType<React.PropsWithChildren<{}>>
    | React.LazyExoticComponent<
        React.ComponentType<React.PropsWithChildren<{}>>
      >;
  initialUrval?: string;
  detaljVyCollectionName?: string;
  detaljVyAssociationName?: string;
  detaljVy?: string;
  /** Överstyr delar av businessconfig för innehållslistan */
  config?: ICustomBusinessConfigs;
  onStartWarningHook?: OnStartWarningHook;
  defaultShowDetailsRight?: ShowDetailsRight;
  /**
   * Size of detail when showDetailsRight is active
   * If a number: Size will be number of 12ths of available space
   * If a string: Size will be assigned to flex-basis (e.g.: "400px")
   * Left side will fill remaining space
   */
  showDetailsRightSize?: ShowDetailsRightSizeType;
  defaultVisningsTyp?: TVisningstyp;
  defaultVisningsTypShowDetailsRight?: TVisningstyp;
  /** Rutinens vy hamnar direkt i redigeringsläge (Direktredigeringsläge) */
  directEditMode?: boolean;
  filterAttributes?: IFilterAttribute[];
  optInDataRefreshDesktop?: boolean;
  optInDataRefreshMobile?: boolean;
  miniCardColor?: (
    data: ICollectionDataType
  ) => CommonPropsAndTypes.MiniCardColorType | undefined;
  unusedRoutineMenuButtons?: BusinessMenuButtons[];
  customUrvalButton?: React.FunctionComponent<React.PropsWithChildren<unknown>>;
  customAddButton?: React.FunctionComponent<
    React.PropsWithChildren<ICustomAddButtonProps>
  >;
  customBottomToolbar?: React.FunctionComponent<
    React.PropsWithChildren<ICustomBottomToolbarProps>
  >;
  customTopToolbar?: React.FunctionComponent<
    React.PropsWithChildren<ICustomBottomToolbarProps>
  >;
  rutinPanelFullHeight?: boolean;
  /** if true, hide list filter component. If breakpoint, hide if screen is smaller than breakpoint */
  hideStandardListFilter?: boolean | Breakpoint;
  hideRutinCollectionMenu?: boolean;
  hideDefaultFunktionsMenyItems?: boolean;
  /** if true, hide the breadcrumbs bar */
  hideBreadcrumbs?: boolean;
  showSelectionNameInList?: boolean;
  /**
   * Funktion som rensar cachen innan man gör ett nytt urval eller öppnar rutinen.
   * Använd den för att rensa data som ur användarens perspektiv hör ihop med det
   * som visas i innehållslistan och som man förväntar sig ska laddas om efter att
   * innehållslistan har uppdaterats.
   */
  urvalCacheInvalidation?: (cache: ApolloCache<object>) => void;
}

export interface IRapport {
  component:
    | React.ComponentType<React.PropsWithChildren<{}>>
    | React.LazyExoticComponent<
        React.ComponentType<React.PropsWithChildren<{}>>
      >;
}
export interface IDelsystem {
  code: string;
  path: string;
  benamning: string;
  rutiner: IRutinInfo[];
  styrvarden: IRutinInfo[];
  rapporter: IRapportInfo[];
  branding: string;
  icon?: React.ReactElement<any>;
  brandingColor: string;
  brandingColorDark: string;
  brandingColorText: string;
}

export const rutinIdToPath = replace(/^rtn/, '');

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const AR = {
  code: 'AR',
  path: 'anlaggning',
  benamning: 'Anläggningsregister',
  rutiner: ARRutinMeny,
  styrvarden: ARStyrvardeMeny,
  rapporter: ARRapportMeny,
  branding: anlaggningBild,
  icon: <EDIcon iconType="delsystem_anlaggning" />,
  brandingColor: '#42A5F5',
  brandingColorDark: '#1E88E5',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const BO = {
  code: 'BO',
  path: 'bokning',
  benamning: 'Bokning',
  rutiner: BORutinMeny,
  styrvarden: BOStyrvardeMeny,
  rapporter: BORapportMeny,
  branding: bokningBild,
  icon: <EDIcon iconType="delsystem_bokning" />,
  brandingColor: '#0097A7',
  brandingColorDark: '#00838F',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const DI = {
  code: 'DI',
  path: 'diarium',
  benamning: 'Diarium',
  rutiner: DIRutinMeny,
  styrvarden: DIStyrvardeMeny,
  rapporter: DIRapportMeny,
  branding: diariumBild,
  icon: <EDIcon iconType="delsystem_diarium" />,
  brandingColor: '#AD1457',
  brandingColorDark: '#880D4F',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const EK = {
  code: 'EK',
  path: 'Ekonomi',
  benamning: 'Ekonomi',
  rutiner: EKRutinMeny,
  styrvarden: EKStyrvardeMeny,
  rapporter: EKRapportMeny,
  branding: ekonomiBild,
  icon: <EDIcon iconType="delsystem_ekonomi" />,
  brandingColor: '#2E7D32',
  brandingColorDark: '#1C5F22',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const GA = {
  code: 'GA',
  path: 'Grav',
  benamning: 'Grav',
  rutiner: GARutinMeny,
  styrvarden: GAStyrvardeMeny,
  rapporter: GARapportMeny,
  branding: gravBild,
  icon: <EDIcon iconType="delsystem_grav" />,
  brandingColor: '#CE93D8',
  brandingColorDark: '#BA69C8',
  brandingColorText: '#273239',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const KJ = {
  code: 'KJ',
  path: 'kremationsjournal',
  benamning: 'Kremationsjournal',
  rutiner: KJRutinMeny,
  styrvarden: KJStyrvardeMeny,
  rapporter: KJRapportMeny,
  branding: kremationsjournalBild,
  icon: <EDIcon iconType="delsystem_kremation" />,
  brandingColor: '#FDD835',
  brandingColorDark: '#FBC02E',
  brandingColorText: '#4E362E',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const KR = {
  code: 'KR',
  path: 'kund',
  benamning: 'Kundreskontra',
  rutiner: KRRutinMeny,
  styrvarden: KRStyrvardeMeny,
  rapporter: KRRapportMeny,
  branding: kundreskontraBild,
  icon: <EDIcon iconType="delsystem_kund" />,
  brandingColor: '#546E7A',
  brandingColorDark: '#455A63',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const LR = {
  code: 'LR',
  path: 'Leverantor',
  benamning: 'Leverantörsreskontra',
  rutiner: LRRutinMeny,
  styrvarden: LRStyrvardeMeny,
  rapporter: LRRapportMeny,
  branding: leverantorsreskontraBild,
  icon: <EDIcon iconType="delsystem_leverantor" />,
  brandingColor: '#757575',
  brandingColorDark: '#606060',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const MU = {
  code: 'MU',
  path: 'musik',
  benamning: 'Musik',
  rutiner: MURutinMeny,
  styrvarden: MUStyrvardeMeny,
  rapporter: MURapportMeny,
  branding: musikBild,
  icon: <EDIcon iconType="delsystem_musik" />,
  brandingColor: '#283593',
  brandingColorDark: '#1C227F',
  brandingColorText: '#fafafa',
};

const BJ = {
  code: 'BJ',
  path: 'bisattningsjournal',
  benamning: 'Bisättningsjournal',
  rutiner: BJRutinMeny,
  styrvarden: BJStyrvardeMeny,
  rapporter: BJRapportMeny,
  branding: bisattningsBild,
  icon: <EDIcon iconType="delsystem_bisattning" />,
  brandingColor: '#5D4037',
  brandingColorDark: '#4e342e',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const OF = {
  code: 'OF',
  path: 'order',
  benamning: 'Order/Fakturering',
  rutiner: OFRutinMeny,
  styrvarden: OFStyrvardeMeny,
  rapporter: OFRapportMeny,
  branding: orderBild,
  icon: <EDIcon iconType="delsystem_order" />,
  brandingColor: '#00695C',
  brandingColorDark: '#004D40',
  brandingColorText: '#fafafa',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const PU = {
  code: 'PU',
  path: 'programutveckling',
  benamning: 'Programutveckling',
  rutiner: PURutinMeny,
  styrvarden: PUStyrvardeMeny,
  rapporter: PURapportMeny,
  branding: '',
  icon: <EDIcon iconType="developer_board" />,
  brandingColor: '',
  brandingColorDark: '',
  brandingColorText: '',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const SYS = {
  code: 'SYS',
  path: 'system',
  benamning: 'Systemadministration',
  rutiner: SYSRutinMeny,
  styrvarden: SYSStyrvardeMeny,
  rapporter: SYSRapportMeny,
  branding: '',
  icon: <EDIcon iconType="settings" />,
  brandingColor: '',
  brandingColorDark: '',
  brandingColorText: '',
};

// fixme: färger till tema, eventuellt kan de vara här, men det är inte optimalt
const TI = {
  code: 'TI',
  path: 'tidredovisning',
  benamning: 'Tidredovisning',
  rutiner: TIRutinMeny,
  styrvarden: TIStyrvardeMeny,
  rapporter: TIRapportMeny,
  branding: '',
  icon: <EDIcon iconType="timer_outlined" />,
  brandingColor: '',
  brandingColorDark: '',
  brandingColorText: '',
};

const DelsystemLista: IDelsystem[] = [
  AR,
  BJ,
  BO,
  DI,
  EK,
  GA,
  KJ,
  KR,
  LR,
  MU,
  OF,
  PU,
  TI,
  SYS,
];
export default DelsystemLista;
